import { render, staticRenderFns } from "./NewSelectBox.vue?vue&type=template&id=0e2fda74&scoped=true&"
import script from "./NewSelectBox.vue?vue&type=script&lang=ts&"
export * from "./NewSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./NewSelectBox.vue?vue&type=style&index=0&id=0e2fda74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2fda74",
  null
  
)

export default component.exports